module.exports = __webpack_public_path__ + "static/media/Bread.09b23548.jpg";